// apiThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAccountGetData = createAsyncThunk(
  "accountGetData/fetchAccountGetData",
  async (_, { getState }) => {
    console.log("Thunk started...");

    const state = getState();
    const sessionToken = localStorage.getItem("token");
    const orgEntity = state.apiData.orgEntity;

    if (!sessionToken) {
      throw new Error("No session token found in localStorage");
    }
    if (!orgEntity) {
      throw new Error("No orgEntity found in state");
    }

    // ✅ Construct payload correctly
    const payload = {
      accountIds: orgEntity,
    };

    // ✅ Make API call with correct headers
    const response = await axios.post(
      "https://v3.dhundhoo.com/accounts/get",
      payload,
      {
        headers: {
          "x-dhundhoo-session": sessionToken,
        },
      }
    );

    return response.data;
  }
);
